module.exports = __webpack_public_path__ + "img/ic-departments-active.413398f3.svg";